module.exports = __webpack_public_path__ + "img/artificial-condition.676302e1.png";